import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Question from '../../entities/question';
import Answer from '../../entities/answer';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
import {deleteAnswer, collectAnswerDeleteImpact} from './answerDeps';
export function canDeleteQuestion(): boolean {
return canCascadeDelete();
}
export function collectQuestionDeleteImpact(question: Question, context: DeleteImpactContext): void {
const key = 'question:' + question.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
workingRows<Answer>('answer', findAll<Answer>('answers')).filter(answer => answer.status !== 'D' && answer.questionId === question.id).forEach(answer => {
if (context.visited.has('answer:' + answer.id)) return;
addDeleteImpact(context, 'answer:' + answer.id, 'answers');
collectAnswerDeleteImpact(answer, context);
});
}
export function deleteImpactQuestion(question: Question): DeleteImpact {
const context = deleteImpactContext();
collectQuestionDeleteImpact(question, context);
return deleteImpactCounts(context);
}
export function deleteQuestion(question: Question, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteQuestion()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectQuestionDeleteImpact(question, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || question.id};
}
const key = 'question:' + question.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Answer>('answer', findAll<Answer>('answers')).filter(answer => answer.status !== 'D' && answer.questionId === question.id).forEach(answer => {deleteAnswer(answer, mergeId, cascade);});

const deleted = question.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.QuestionActions.removeQuestionQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceQuestion(question: Question, replaceWith: Question, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = question.id;}
const _work = workingSet();




workingRows<Answer>('answer', findAll<Answer>('answers')).filter(answer => answer.status !== 'D' && answer.questionId === question.id).forEach(answerTemp => {
const _answer = ((_work.get('answer:' + answerTemp.id) ?? answerTemp) as Answer).clone();
if (_answer.status === 'D') return;
_answer.questionId = replaceWith.id;
_answer.status = 'U';
_answer.addedOn = newHRTimestamp();
_answer.addedBy = getCurrentUserId();
_answer.importSource = targetImportSource;
_answer.importId = mergeId;
_work.set('answer:' + _answer.id, _answer);
store.dispatch(Actions.AnswerActions.saveAnswerQueue(_answer));
});
return question;
}
